import React from 'react'

import { Alignment, theme } from '@acorns/web-components'
import { useRemoteStrings } from '@acorns/web-utils'
import { motion } from 'framer-motion'

import { currencyFormatterNoTrailingZeros } from '../../../../helpers'
import { AgeOfTransferLabel, StyledPopover } from './styled-components'

export const Tooltip: React.FC<{
  isAgeOfTransfer: boolean
  isDragging: boolean
  projectionTotal: number
  snapIndex: number
}> = ({ isAgeOfTransfer, isDragging, projectionTotal, snapIndex }) => {
  const formattedProjection = currencyFormatterNoTrailingZeros(projectionTotal)
  const { getRemoteString } = useRemoteStrings()

  return (
    <motion.div
      key={'slider-tooltip'}
      initial={{ opacity: 0, scale: 0 }}
      animate={{
        opacity: 1,
        scale: 1,
      }}
      transition={{
        duration: 0.15,
        ease: 'easeInOut',
      }}
      exit={{ opacity: 0, scale: 0 }}
    >
      <StyledPopover
        alignment={Alignment.TopCenter}
        arrowColor={theme.colors.slate}
        arrowSize={5}
        content={
          <>
            {isAgeOfTransfer && (
              <AgeOfTransferLabel>
                {getRemoteString({
                  key: 'early.potential.graph.tooltip.age_of_transfer.label',
                })}
              </AgeOfTransferLabel>
            )}
            <span>{formattedProjection}</span>
          </>
        }
        gutter={4}
        length={
          isAgeOfTransfer
            ? formattedProjection.length > 11
              ? formattedProjection.length
              : 11
            : formattedProjection.length
        }
        shiftLeft={snapIndex > 7}
        visible={isDragging}
      />
    </motion.div>
  )
}
